import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { DxButtonGroupComponent, DxSchedulerComponent, DxTagBoxComponent, DxTooltipComponent } from 'devextreme-angular';
import {firstValueFrom, forkJoin, take} from 'rxjs';
import {
  DocumentType,
  EOperationStateType, OperationStates, OperationStateTypeColors,
  Organization,
  Plant,
  ProductionOrder,
  ProductionOrderOperation,
  ProductionOrderPlanner,
  ProductionOrderPlannerOperation,
  TId,
  Worker
} from '../../../../models';
import { MasterApiService } from '../../../../services/master-api.service';
import { ItemClickEvent } from 'devextreme/ui/button_group';
import { AppointmentClickEvent, AppointmentFormOpeningEvent, AppointmentUpdatedEvent, OptionChangedEvent } from 'devextreme/ui/scheduler';
import { secondsToHhmmss, hhmmssToTimespan, fromTimeSpanStringToSeconds, joinWithSeparator } from '../../../../libs/utils';
import DataSource from 'devextreme/data/data_source';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../../../../services/storage.service';
import { AuthService } from '../../../../services/auth.service';
import {
  OmsManufacturingOrdersEditComponent
} from '../../../oms/production/oms-manufacturing-orders/oms-manufacturing-orders-edit/oms-manufacturing-orders-edit.component';
import { TabRole, TabsService } from '../../../../libs/components/tabs-host/tabs.service';
import {FormBuilder, FormGroup} from "@angular/forms";
import {AlertService} from "../../../../services/alert.service";

enum ActionType {
  Split = 1,
  Delete = 2,
  Reschedule = 3
}


interface OperationTarjet extends ProductionOrderPlannerOperation {
  workersList?: PlannerWorker[];
  productionOrderStatus?: string;
  timeslotId?: TId;
  operationDuration?: string;
  operationStartDate?: Date;
  operationId?: TId;
  color?: string;
  document?: string;
  subject?: string;
  documentTypeId?: TId;
  operationStateId?: TId;
  documentTypeStateId?: TId;
  natureStateId?: number;
  productionOrderDocumentTypeName?: string;
  projects?: string;
  organizations?: string;
}

interface PlannerWorker extends Worker {
  avatar?: string;
  isFree?: boolean;
}

interface PlannerFilters {
  workerIds?: TId[],
  plantIds?: TId[],
  documentTypeIds?: TId[],
  documentTypeStateIds?: TId[],
  startDate?: string,
  endDate?: string,
  organizationIds?: TId[],

}

const NatureIdProductionOrder = 3

@Component({
    selector: 'app-workers-planner',
    templateUrl: './workers-planner.component.html',
    styleUrls: ['./workers-planner.component.sass'],
    standalone: false
})
export class WorkersPlannerComponent implements OnInit, AfterViewInit {

  joinWithSeparator = joinWithSeparator;
  selectedProductionOrderId: TId | null = null;
  operationDatesForm?: FormGroup;

  readonly stateColors: { [key: number]: string } = {
    [EOperationStateType.Pending]: OperationStateTypeColors[EOperationStateType.Pending],
    [EOperationStateType.Pause]: OperationStateTypeColors[EOperationStateType.Pause],
    [EOperationStateType.Start]: OperationStateTypeColors[EOperationStateType.Start],
    [EOperationStateType.Complete]: OperationStateTypeColors[EOperationStateType.Complete],
  };
  operationStates: { [key: number]: string } = {};
  onAppointmentClick(event: AppointmentClickEvent) {
    event.cancel = true;
    if (!event!.appointmentData!['id']) {
      return;
    }
    const editedTicket = event.appointmentData as OperationTarjet
    this.selectedOperation = editedTicket;
    this.workersOfSelectedOperation = editedTicket?.workersList?.map(item => item.id) || [] as TId[];
    //this.editComponentVisible = true;
    this.selectedProductionOrderId = editedTicket.productionOrderId;
  }

  private hasUserScrolled = false;
  private savedScrollPosition: any = null;

  onAppointmentDbClick(event: AppointmentClickEvent) {
    event.cancel = true;
    if (!event!.appointmentData!['id']) {
      return;
    }
    const editedTicket = event.appointmentData as OperationTarjet
    this.selectedOperation = editedTicket;
    this.workersOfSelectedOperation = editedTicket?.workersList?.map(item => item.id) || [] as TId[];
    this.editComponentVisible = true;
  }
  onAppointmentRendered(e: any) {
    const element = e.appointmentElement;

    if(!element) return;
    // Handle hover
    element.addEventListener('mouseenter', () => {
      this.tooltipData = e.appointmentData;
      this.tooltip.instance.option('target', element);
      this.tooltipVisible = true;
    });

    element.addEventListener('mouseleave', () => {
      this.tooltipVisible = false;
    });
  }
  async onAppointmentUpdated($event: AppointmentUpdatedEvent) {
    const operationFromPlanner = $event.appointmentData as OperationTarjet;
    const operation = { ...($event.appointmentData as ProductionOrderOperation) };
    const startTime = new Date(operationFromPlanner.startTime);
    const endDate = new Date(operationFromPlanner.endTime);
    await firstValueFrom(this.api.resources.operations.operationTimeSlots(operationFromPlanner.productionOrderId, operationFromPlanner!.operationId!).put(
      {
        id: operationFromPlanner.timeslotId,
        startTime: startTime,
        endTime: endDate,
        duration: '',
      }
    ));

    const _operation = this.operations.find((op) => op.operationId === operation.id);
    if (_operation)
      _operation.duration = operation.duration;
  }

  operations: OperationTarjet[] = [];
  selectedOperation?: OperationTarjet | undefined = undefined;
  workersOfSelectedOperation: TId[] = [];
  organizations: Organization[] = [];
  planner: ProductionOrderPlanner[] = [];
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  currentDate: Date = new Date();
  drawerOpened: boolean = false;
  productionOrders: ProductionOrder[] = [];
  workers: PlannerWorker[] = [];
  plants: Plant[] = [];
  statuses: any[] = [];
  documentTypes: DocumentType[] = [];
  tagBoxValueWorker: TId[] = [];
  tagBoxValuePlants: TId[] = [];
  ActionType = ActionType;
  tagBoxValueOrganizations: TId[] = [];
  tagBoxxValueDocumentTypes: TId[] = [];
  tagBoxValueDocumentTypeStates: TId[] = [];
  currentView: string = 'week';
  views = ['day', 'week', 'month'];
  lastDate: Date = new Date();
  startFistOperationHour: number = 0;
  tooltipVisible = false;
  tooltipData: any = null;
  loadingVisible: boolean = false;
  currentCompanyName: string = '';
  organitzationsDataSource = new DataSource(this.api.resources.organization.organizations.asDataSourceOptions(100));

  @ViewChild('scheduler', { static: false }) scheduler?: DxSchedulerComponent;
  @ViewChild('buttonGroup1', { static: false }) buttonGroup1?: DxButtonGroupComponent;
  @ViewChild('statusesTagBox', { static: false }) statusesTagBox?: DxTagBoxComponent;
  @ViewChild('tooltip', { static: false }) tooltip!: DxTooltipComponent;

  onMouseLeave() {
    this.scheduler?.instance.hideAppointmentTooltip();
  }

  onMouseEnter(e: any, model: any) {
    this.scheduler?.instance.showAppointmentTooltip(
      model.appointmentData,
      e.target
    );
  }

  selectedCellDuration: string = '15';

  cellDurationsZoom: { icon: string; cellDuration: string; hint: string }[] = [
    { icon: 'zoom_out', cellDuration: '-', hint: '-' },
    { icon: 'zoom_in', cellDuration: '+', hint: '+' }
  ];

  utilitiesButtons: { icon: string; hint: string }[] = [
    { icon: 'refresh', hint: this.tr.instant('common.refresh') },
  ];


  cellDurations: { cellDuration: string; hint: string }[] = [
    { cellDuration: '5', hint: '5' },
    { cellDuration: '15', hint: '15' },
    { cellDuration: '30', hint: '30' },
    { cellDuration: '60', hint: '60' }
  ];
  editComponentVisible: boolean = false;
  rescheduleOperation: boolean = false;
  activeFilters: string[] = [];

  constructor(private api: MasterApiService,private fb: FormBuilder , private tr: TranslateService, private storage: StorageService, private auth: AuthService, private tab: TabsService, private alert: AlertService) { }

  async ngOnInit(): Promise<void> {
    const companies = await firstValueFrom(this.storage.getCompanies())
    this.currentCompanyName = companies.find(company => company.id === this.auth.userValue?.lastCompanyId)?.fiscalName ?? '';
    this.loadingVisible = true;
    OperationStates.forEach(s => this.operationStates[s.id] = this.tr.instant('enumeration.OperationStates.' + s.name));
    const [plants, workers, documentTypes, organizations] = await firstValueFrom(
      forkJoin([
        this.api.resources.plants.getAll(),
        this.api.resources.workers.getAll(),
        this.api.resources.operations.documentTypes.getAll({ natureid: NatureIdProductionOrder }),
        this.api.resources.organization.organizations.getAll(),

      ])
    );

    this.plants = plants;
    this.workers = workers;
    this.documentTypes = documentTypes;
    this.organizations = organizations;
    await this.getPlanner(true);
    this.loadingVisible = false;
  }

  ngAfterViewInit() {
    if (!this.scheduler) return;

    const workSpace = (this.scheduler.instance as any).getWorkSpace();
    const scrollable = workSpace.getScrollable();

    scrollable.on('scroll', () => {
      this.hasUserScrolled = true;
      this.savedScrollPosition = scrollable.scrollOffset();
    });
  }



  async refresh(){
    this.loadingVisible = true;
    await this.getPlanner(false);
    this.loadingVisible = false;
  }

  async onDropDownBoxValueChanged(event: any) {
    if (!event || event.length === 0) {
      this.statuses = [];
      this.tagBoxValueDocumentTypeStates = [];
      this.statusesTagBox?.instance.repaint();
      return
    }
    event.forEach(async (value: any) => {
      this.statuses = [...this.statuses, ...await firstValueFrom(this.api.resources.operations.documentTypeStatesByDocumentId(value).getAll())];
    })
  }


  async getPlanner(isFirstLoad:boolean):Promise<void> {
    if (!this.scheduler) return;
    const filters: PlannerFilters = this.calculateDatesForView();
    filters.plantIds = this.tagBoxValuePlants?.map(item => item);
    filters.workerIds = this.tagBoxValueWorker?.map(item => item);
    filters.documentTypeIds = this.tagBoxxValueDocumentTypes?.map(item => item);
    filters.documentTypeStateIds = this.tagBoxValueDocumentTypeStates?.map(item => item);
    filters.organizationIds = this.tagBoxValueOrganizations?.map(item => item);

    this.planner = await firstValueFrom(this.api.getPlannerProductionOrders(filters));
    this.operations = [];

    this.planner.forEach((planner) => {
      planner.operations.forEach((operation) => {
        operation.timeSlots.forEach((timeSlot) => {
          const operationTarjet: OperationTarjet = { ...operation };

          operationTarjet.workersList = this.workers.filter((w) =>
            operationTarjet.workers?.includes(w.id.toString())
          );

          operationTarjet.color = operationTarjet.operationTypeCompletedColor;
          operationTarjet.document = planner.document;
          operationTarjet.operationId = operation.id;
          operationTarjet.id = timeSlot.id;
          operationTarjet.startTime = timeSlot.startTime;
          operationTarjet.endTime = timeSlot.endTime;
          operationTarjet.operationDuration = operationTarjet.duration;
          operationTarjet.operationStartDate = timeSlot.startTime;
          operationTarjet.duration = timeSlot.duration;
          operationTarjet.timeslotId = timeSlot.id;
          operationTarjet.subject = planner.subject;
          operationTarjet.documentTypeId = planner.documentTypeId;
          operationTarjet.productionOrderDocumentTypeName = planner.documentTypeName;
          operationTarjet.documentTypeStateId = planner.documentTypeStateId;
          operationTarjet.natureStateId = planner.natureStateId;
          operationTarjet.projects = planner.projectsInfo?.projectDescriptions;
          operationTarjet.organizations = planner.projectsInfo?.organizationsInfo;

          // Color según estado
          if (operationTarjet.operationStateId === 1) {
            operationTarjet.color = operationTarjet.operationTypeMainColor || operationTarjet.color;
          } else {
            operationTarjet.color = operationTarjet.operationTypeCompletedColor || operationTarjet.color;
          }

          if (planner.natureStateId === 305 || planner.natureStateId === 304) {
            operationTarjet.color = '#5e5e5e';
          }

          operationTarjet.productionOrderStatus = planner.state;

          this.operations.push(operationTarjet);
        });
      });
    });

    await this.scrollToFirstOperation(isFirstLoad);
  }

  getFirstOperationDate(): Date | null {
    if (!this.operations || this.operations.length === 0) return null;

    const firstOp = this.operations.reduce((prev, curr) => {
      const prevDate = new Date(prev.startTime);
      const currDate = new Date(curr.startTime);
      return currDate < prevDate ? curr : prev;
    });

    return new Date(firstOp.startTime);
  }

  async onActionClick(event: any, element: OperationTarjet) {
    if(event.itemData.id === ActionType.Split){
      await firstValueFrom(this.api.splitOperationTimeslot(element.productionOrderId, element.operationId!, element.timeslotId!))
      await  this.refresh()
    }
    if(event.itemData.id === ActionType.Delete){
      await firstValueFrom(this.api.deleteOperationTimeslot(element.productionOrderId, element.operationId!, element.timeslotId!))
      await  this.refresh()
    }
    if(event.itemData.id === ActionType.Reschedule){
      this.selectedOperation = element;
      this.initOperationTimes(element);

      this.rescheduleOperation = true;
    }
  }

  initOperationTimes(operationTarjet: OperationTarjet) {
    this.operationDatesForm = this.fb.group({
      startTime: [operationTarjet.operationStartDate],
      duration: [operationTarjet.operationDuration],
    });
  }

  async saveRescheduleOperation(){
    this.rescheduleOperation = false;
    let duration = this.operationDatesForm!.controls['duration'].value
    if(!duration.includes(':')){
      duration = secondsToHhmmss(fromTimeSpanStringToSeconds(this.operationDatesForm!.controls['duration'].value))
    }

    const data = {
     startTime:this.operationDatesForm?.controls['startTime'].value,
     duration: duration
    }
    await firstValueFrom(this.api.rescheduleOperation(this.selectedOperation!.productionOrderId, this.selectedOperation!.operationId!, data))
    this.operationDatesForm = undefined;
    await  this.refresh()
  }


  toggleDrawer() {
    this.drawerOpened = !this.drawerOpened;
    setTimeout(async () => {
      this.scheduler?.instance.repaint();
      await this.scrollToFirstOperation();
    }, 500)
  }

  changeCellDuration($event: ItemClickEvent) {
    const value = $event.itemData.cellDuration;
    this.selectedCellDuration = value;
    this.scheduler!.cellDuration = parseInt(value);
    this.scheduler?.instance.repaint();
    const date = new Date();
    this.scheduler?.instance.scrollTo(date);
  }

  changeCellDurationZoom($event: ItemClickEvent) {
    const durations = [5, 15, 30, 60];
    const value = $event.itemData.cellDuration; // '-' or '+'

    const currentDuration = this.scheduler!.cellDuration;
    let newDuration = currentDuration;

    if (value === '-') {
      const nextIndex = durations.indexOf(currentDuration) + 1;
      if (nextIndex < durations.length)
        newDuration = durations[nextIndex];
    }

    if (value === '+') {
      const prevIndex = durations.indexOf(currentDuration) - 1;
      if (prevIndex >= 0)
        newDuration = durations[prevIndex];
    }

    if (currentDuration !== newDuration) {
      this.selectedCellDuration = newDuration.toString();
      this.scheduler!.cellDuration = newDuration;
      this.scheduler?.instance.repaint();
      this.scheduler?.instance.scrollTo(new Date());
      this.buttonGroup1!.selectedItemKeys = [newDuration.toString()];
    }
  }

  async aplyFilters() {
    this.loadingVisible = true;
    this.allSelectedValues()
    await this.getPlanner(false);
    this.scheduler?.instance.repaint();
    await this.scrollToFirstOperation(false);
    setTimeout(() => {
      this.toggleDrawer();
    },
      200
    );
    this.loadingVisible = false;
  }

  allSelectedValues = () => {
    this.activeFilters = [
      ...(this.tagBoxValueWorker?.length ? this.workers.filter(item => this.tagBoxValueWorker.includes(item.id)).map(item => item.name) : []),
      ...(this.tagBoxValuePlants?.length ? this.plants.filter(item => this.tagBoxValuePlants.includes(item.id)).map(item => item.name) : []),
      ...(this.tagBoxxValueDocumentTypes?.length ? this.documentTypes.filter(item => this.tagBoxxValueDocumentTypes.includes(item.id)).map(item => item.name) : []),
      ...(this.tagBoxValueDocumentTypeStates?.length ? this.statuses.filter(item => this.tagBoxValueDocumentTypeStates.includes(item.id)).map(item => item.name) : []),
      ...(this.tagBoxValueOrganizations?.length ? this.organizations.filter(item => this.tagBoxValueOrganizations.includes(item.id)).map(item => item.legalName) : []),
    ];
  }

  async onOptionChanged($event: OptionChangedEvent) {
    if ($event.name === 'currentView') {
      this.loadingVisible = true;
      this.currentView = $event.value;
      this.getPlanner(true);
      this.loadingVisible = false;

    } else if ($event.name === 'currentDate') {
      this.loadingVisible = true;
      this.lastDate = new Date($event.value);
      await this.getPlanner(true);
      this.loadingVisible = false;
    }
  }

  private nextFrame(): Promise<void> {
    return new Promise(resolve => requestAnimationFrame(() => resolve()));
  }

  async scrollToFirstOperation(isFirstLoad: boolean = false) {
    if (this.savedScrollPosition && this.scheduler && !isFirstLoad) {
      const schedulerInstance = this.scheduler.instance;
      schedulerInstance.repaint();
      await this.nextFrame();
      await this.nextFrame();

      // Importante: volver a obtener el scrollable DESPUÉS del repaint
      const workSpace = (schedulerInstance as any).getWorkSpace();
      const scrollable = workSpace.getScrollable();

      scrollable.scrollTo(this.savedScrollPosition);
      return
    }
    if (!this.scheduler) return;

    const firstOpDate = this.getFirstOperationDate();
    const currentDate = this.lastDate || new Date();

    const maxAttempts = 10;
    let attempt = 0;

    while (attempt < maxAttempts) {
      const schedulerStart = this.scheduler.instance.getStartViewDate();
      const schedulerEnd = this.scheduler.instance.getEndViewDate();

      if (currentDate >= schedulerStart && currentDate <= schedulerEnd) {
        const now = new Date();
        const scrollDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        );

        this.scheduler.instance.scrollTo(scrollDate);
        break;
      }


      if (firstOpDate && (firstOpDate < schedulerStart || firstOpDate > schedulerEnd)) {
        this.scheduler.instance.scrollTo(firstOpDate);
      } else {
        break;
      }

      // Esperamos un tick para que el scheduler renderice
      await new Promise(resolve => setTimeout(resolve, 100));
      attempt++;
    }
  }


  calculateDatesForView = () => {
    let startDate: Date = new Date;
    let endDate: Date = new Date;

    if (this.currentView === 'month') {
      startDate = new Date(this.lastDate.getFullYear(), this.lastDate.getMonth(), 1, 12, 0, 0);
      endDate = new Date(this.lastDate.getFullYear(), this.lastDate.getMonth() + 1, 0, 12, 0, 0);
    } else if (this.currentView === 'week') {
      const dayOfWeek = (this.lastDate.getDay() + 6) % 7;
      startDate = new Date(this.lastDate);
      startDate.setDate(this.lastDate.getDate() - dayOfWeek);
      startDate.setHours(12, 0, 0)
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(12, 0, 0);
    } else if (this.currentView === 'day') {
      startDate = new Date(this.lastDate);
      this.lastDate.setDate(this.lastDate.getDate() + 1);
      endDate = new Date(this.lastDate);
    }

    return {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    } as PlannerFilters;
  };

  onAppointmentFormOpening(event: AppointmentFormOpeningEvent) {
    event.cancel = true;
  }

  async move($event: { workers: PlannerWorker[]; stateid: TId; documentId: TId; }) {
    const startTime = new Date(this.selectedOperation!.startTime);
    startTime.setDate(startTime.getDate() + 7);
    const timeZoneOffset = startTime.getTimezoneOffset() / 60;
    startTime.setHours(startTime.getHours() - timeZoneOffset);

    const endTime = new Date(this.selectedOperation!.endTime);
    endTime.setDate(endTime.getDate() + 7);
    endTime.setHours(endTime.getHours() - timeZoneOffset);

    await firstValueFrom(this.api.resources.operations.operationTimeSlots(this.selectedOperation!.productionOrderId, this.selectedOperation!.operationId!).put(
      {
        id: this.selectedOperation!.timeslotId,
        startTime: startTime,
        endTime: endTime,
        duration: '',
      }
    ));

    this.getPlanner(false);
    this.scheduler?.instance.repaint();
    await this.scrollToFirstOperation(false);
    this.editComponentVisible = false;

  }
  async saveChanges($event: { workers: TId[], stateid: TId, documentId: TId, times:{startTime: Date; endTime: Date;} | null }) {
    this.loadingVisible = true;
    if ($event !== null && $event.workers !== null && $event.workers !== this.selectedOperation?.workers) {
      await firstValueFrom(this.api.resources.operations.productionOrderOperations(this.selectedOperation!.productionOrderId).patch(this.selectedOperation!.operationId!, { action: 'UpdateWorkers', workers: $event.workers }));
    }
    if ($event !== null && $event.stateid !== null) {
      await firstValueFrom(this.api.resources.operations.documents.patch($event.documentId, { action: 'changeState', stateId: $event.stateid }));
    }
    if($event !== null && $event.times !== null) {
      await firstValueFrom(this.api.resources.operations.operationTimeSlots(this.selectedOperation!.productionOrderId, this.selectedOperation!.operationId!).put(
        {
          id: this.selectedOperation!.timeslotId,
          startTime: $event.times.startTime,
          endTime: $event.times.endTime,
          duration: '',
        }
      ));
    }
    this.editComponentVisible = false;
    this.getPlanner(false);
    this.scheduler?.instance.repaint();
    const date = new Date();
    await this.scrollToFirstOperation(false);
    this.loadingVisible = false;
  }

  getLogo(name: string) {
    const nameParts = name.trim().split(' ');

    // Get the first letter of the first name and last name
    const initials = nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();

    return initials;
  }

  navigateToProductionOrder(e: any) {
    this.editComponentVisible = false;
    const cmpt = this.tab.createTab(OmsManufacturingOrdersEditComponent, TabRole.EDITION, { inputPrms: { id: e.productionOrderId } });
    cmpt.component.instance.entityChanged.pipe(take(1)).subscribe(async updatedItem => {
      await this.refresh()
    });
  }

  formatProjectAndOrganizationsStrings(input?: string | null): string {
    if (!input?.trim()) return '';

    const values = Array.from(input.matchAll(/<(.*?)>/g))
      .map(match => match[1])
      .filter(Boolean);

    return values
      .reduce((acc: string[][], value, index) => {
        if (index % 2 === 0) acc.push([value]);
        else acc[acc.length - 1].push(value);
        return acc;
      }, [])
      .map(chunk => chunk.join(' '))
      .join(' | ');
  }


  formatTime = hhmmssToTimespan;
}
